import {
  WordLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { WordReferenceDictionaryScreenSuspense } from "#word-reference-dictionary-screen-suspense";

export function WordReferenceDictionaryScreen({ word }: { word: string }) {
  return (
    <SuspensePageBoundary fallback={<WordLayoutSkeleton />} location={import.meta.location}>
      <WordReferenceDictionaryScreenSuspense word={word} />
    </SuspensePageBoundary>
  );
}
